import { render } from "./FifthStep.vue?vue&type=template&id=38fb9f9e&scoped=true"
import script from "./FifthStep.vue?vue&type=script&lang=js"
export * from "./FifthStep.vue?vue&type=script&lang=js"

import "./FifthStep.vue?vue&type=style&index=0&id=38fb9f9e&lang=scss&scoped=true"

import exportComponent from "C:\\BestPhone\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fb9f9e"]])

export default __exports__